import { action } from 'typesafe-actions';
import { CidadeOrigemTypes, ICidadeOrigem } from './types';

export const loadRequest = () => action(CidadeOrigemTypes.LOAD_REQUEST, {});
export const loadSuccess = (data: ICidadeOrigem[]) =>
  action(CidadeOrigemTypes.LOAD_SUCCESS, { data });
export const loadFailure = () => action(CidadeOrigemTypes.LOAD_FAILURE, {});
